module.exports = __webpack_public_path__ + "img/sediu.69fc5ef7.png";